module.exports = __webpack_public_path__ + "media/page_turn.0ac6ae7c.wav";